export const MARGIN_BOTTOM_FROM_CHEVRONES = 16;
export const HEIGHT_FROM_CHEVRONES = 22;
